import { withLazy } from 'app/hocs/withLazy'

export const Generator = withLazy(() => import('features/Generator/pages/Generator'))
